import { useMutation } from '@apollo/client';

import type { SaveTraffickingFiltersMutation, SaveTraffickingFiltersMutationVariables } from '../../../../apis/graphql';
import { SearchParams } from '../../../../constants';
import { useFiltersContext } from '../../../../contexts/FilterContext';
import { convertFiltersToTraffickingFiltersInput } from '../../utils';
import { useGetTraffickingFilterConfig } from '../AdditionalFilters/hooks';
import { SAVE_TRAFFICKING_FILTERS } from './queries/saveTraffickingFilters';

export type UseSaveTraffickingFilters = {
  loading: boolean;
  saveFilters: () => Promise<string>;
};

export const useSaveTraffickingFilters = (): UseSaveTraffickingFilters => {
  const [saveTraffickingFilters, { loading }] = useMutation<
    SaveTraffickingFiltersMutation,
    SaveTraffickingFiltersMutationVariables
  >(SAVE_TRAFFICKING_FILTERS);

  const { filterConfigs } = useGetTraffickingFilterConfig();
  const { filters } = useFiltersContext();
  const saveFilters = async (): Promise<string> => {
    const { data } = await saveTraffickingFilters({
      variables: {
        input: convertFiltersToTraffickingFiltersInput(filters, filterConfigs),
      },
    });

    const shareableId = data?.saveTraffickingFilters.id;

    if (!shareableId) {
      throw new Error();
    }

    const { protocol, host } = window.location;

    return `${protocol}//${host}/trafficking?${SearchParams.ShareableId}=${shareableId}`;
  };

  return {
    saveFilters,
    loading,
  };
};
